import DrawDownDesc from "./DrawDownDesc";
import WhyConsider from "./WhyConsider";

const posts = [
  {
    id: 1,
    title: "What are the key benefits?",
    href: "#",
    description: <DrawDownDesc />,
    date: "Mar 16, 2020",
    datetime: "2020-03-16",
    category: { title: "Platinum Draw Down", href: "#" },
  },
  {
    id: 2,
    title: "Consider if you?",
    href: "#",
    description: <WhyConsider />,
    date: "Mar 16, 2020",
    datetime: "2020-03-16",
    category: { title: "Platinum Draw Down", href: "#" },
  },
  {
    id: 3,
    title: "What are the key benefits?",
    href: "#",
    description:
      "You can invest a minimum of Kshs. 5 million from your retirement savings. You can also continuously top up with funds from other source         At the end of the statutory period of 10 years, you can exercise any of the following options         Receive a refund of the remaining fund         Continue with the drawdown arrangement         Purchase an annuity to provide an income for life         You can choose the frequency of accessing your retirement income subject to statutory limits which can be monthly, quarterly, semi-annually, annually or on request.   You can also choose to access minimal or no income before 65 years to minimize on payable tax or choose to access less or more funds to suit your income needs.   You can also adjust the frequency of accessing he benefits art the beginning of every year.",
    date: "Mar 16, 2020",
    datetime: "2020-03-16",
    category: { title: "Platinum Draw Down", href: "#" },
  },
];

export default function DrawDown() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Platinum Draw Down
          </h2>
          <p className="mt-2 text-lg leading-8 text-gray-600">
            An Income Drawdown Plan is an investment product that provides you
            with an income from your retirement savings. The plan allows you
            access to your retirement savings as an income while keeping the
            balance invested.
          </p>
          <p className="mt-2 text-lg leading-8 text-gray-600">
            The plan runs for a minimum of 10 years during which you receive
            income from the fund. The fund is invested in a guaranteed fund
            where it is protected against reduction.{" "}
          </p>
        </div>
        <a
          href="#"
          className="mt-10 block w-48 rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Application Form
        </a>
        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {posts.map((post) => (
            <article
              key={post.id}
              className="flex max-w-xl  items-start justify-between"
            >
              <div className="flex items-center gap-x-4 text-xs"></div>
              <div className="group relative">
                <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                  <a href={post.href}>
                    <span className="absolute inset-0" />
                    {post.title}
                  </a>
                </h3>
                <p className="mt-5  text-sm leading-6 text-gray-600">
                  {post.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
